var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{ref:"modal",attrs:{"size":"lg","hide-footer":""}},[_c('update-form',{attrs:{"data":_vm.request},on:{"click-save-button":_vm.handleClickSaveButton}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }